/**
 * this file contains all constant we need to work the application
 */

// App Infos
export const APP_URL = process.env.REACT_APP_P4C_APP_URL || "https://p4c-nbar.mypanoptes.com/proxy/";

export const APP_NAME = "POD4Carriers";
export const APP_VERSION = "1.0.0.0183"; // Version format : Vx.yy.zz.wwww

export const APP_DEFAULT_CUSTOMER = "HEPPNER";

// WS Infos
export const WS_SCAN = "?action=SCAN&client_id=%ID%&K=%KEY%&barcode=%CAB%&szShipmentType=%SHIPTYPE%";
export const WS_UPLOAD = "?action=UPLOAD&client_id=%ID%&K=%KEY%";
export const WS_SETTINGS = "?action=SETTINGS&client_id=%ID%";

export const HTTP_TIMEOUT = 60000;
export const GPS_TIMEOUT = 10000;
export const THREAD_TIMER_INITIAL = 1000;
export const THREAD_TIMER = 120000;

// Available languages
export const LANG_DEFINED = ["en", "fr", "es", "it", "de", "pl"];

// Photo configuration
export const PHOTO_QUALITY = 0.90;
export const PHOTO_MAXRES = 1300;

// File name regex
export const REGEX_DCS = new RegExp(".dcs$");
export const REGEX_PIC = new RegExp(".jpg$");

// File mime type
export const MIME_DCS = "text/plain";
export const MIME_PIC = "image/jpeg";

// Screens name
export const SCREEN_HOME = "HOME";
export const SCREEN_DELIVERY = "DELIVERY";
export const SCREEN_COLLECT = "COLLECT";
export const SCREEN_END = "END";
export const SCREEN_HISTORIC = "HISTORIC";
export const SCREEN_CONFIRMATION = "CONFIRMATION";

// DCS Infos
export const FILE_ID = "STATUS";
export const ROUND_ID = "ROUND";
export const DRIVER_ID = "P4C";
export const FILE_INDEX ="001";
export const FILE_VERSION = "V1.00";
export const VEHICULE_ID = "";
export const FREE_TEXT = "";
export const GEOCODING_TYPE = "GDD";
export const CAB_MANUAL = "M";
export const CAB_SCAN = "C";
export const TERMINALID_LENGTH = 20;
export const GPSCOORD_LENGTH = 16;
export const SHIP_TYPE_DEL = "D";
export const SHIP_TYPE_COL = "C";
export const COMMENT_LENGTH = 70;
export const WOEHL_CUSTOMER = "HeppnerWoehl";
export const WOEHL_EXT = "_WOEH";

// Shipment db purge (in hours)
export const DB_PURGE = 24;

// Email pattern regex
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export var APP_LOG_ENABLED = true; // Enable or disable logging